import apiClient from "../apiClient";
const urlPath = "/api/matches-fetch/";
/**
 * Hole alle Matches von der API.
 * @returns {Promise<Array>} Eine Liste von Matches.
 */
export const fetchMatches = async () => {
  const response = await apiClient.get(urlPath);
  console.info("Fetched matches:", response.data);
  return response.data; // Erwartet eine Liste von Matches
};

/**
 * Hole ein einzelnes Match von der API.
 * @param {number} matchId Die ID des Matches.
 * @returns {Promise<Object>} Das Match-Objekt.
 */
export const fetchMatchById = async (matchId) => {
  const response = await apiClient.get(`${urlPath}${matchId}/`);
  return response.data; // Erwartet ein einzelnes Match
};
 